import { Call, Device } from '@twilio/voice-sdk';
import { useRef } from 'react';
import { isDev } from 'utils/uiHelpers';

export const useTwilioDevice = () => {
  const device = useRef<Device>();

  const setupDevice = (token: string, edge?: string) => {
    if (device.current) device.current.destroy();
    device.current = new Device(token, {
      codecPreferences: [Call.Codec.Opus, Call.Codec.PCMU],
      logLevel: isDev() ? 'DEBUG' : undefined,
      edge,
    });
    device.current.audio?.setAudioConstraints({
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: true,
    });
    return device.current;
  };

  const destroyDevice = () => {
    device.current?.destroy();
    device.current = undefined;
  };

  return { device, setupDevice, destroyDevice };
};
